export const ACTIONS_USER = {
  INVALIDATE: 'USERS_INVALIDATE',
  RECEIVE: 'USERS_RECEIVE',
  DELETE: 'USER_DELETE',
  UPDATE: 'USER_UPDATE',
};

const userConstants = {};

export default userConstants;
